import { Skeleton } from "antd"
import { SkeletonButtonProps } from "antd/lib/skeleton/Button"
import React from "react"

interface LoadingDataInterface extends SkeletonButtonProps {}

const LoadingData: React.FC<LoadingDataInterface> = ({ size, active, ...rest }) => <Skeleton.Button size={size ?? "small"} active={active ?? true} {...rest} />

export default LoadingData
